import type { IconSvgObject } from './types';

const HazeIcon: IconSvgObject = [
  ["path", { d: "M8.53513 13.9922C8.19479 13.4038 8 12.7208 8 11.9922C8 9.78305 9.79086 7.99219 12 7.99219C14.2091 7.99219 16 9.78305 16 11.9922C16 12.7208 15.8052 13.4038 15.4649 13.9922", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 18H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 22H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 11.995H4M20 11.995H22M11.995 4V2M17.6533 6.34047L19.0675 4.92626M6.33963 6.34837L4.92542 4.93415", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default HazeIcon;
